import React from "react";

const millisecondsToTime = (milliseconds) => {
    const seconds = Math.floor((milliseconds / 1000) % 60);
    const minutes = Math.floor((milliseconds / (1000 * 60)) % 60);
    const hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);
    const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));

    return { days, hours, minutes, seconds };
};

const Timer = ({ timeTillEvent }) => {
    const { days, hours, minutes, seconds } = millisecondsToTime(timeTillEvent);

    return (
        <div style={{ paddingTop: '100px' }}>
            <h4 className="timer-title">The conference starts in</h4>
            {/*<div className="line-container">*/}
            {/*    <span className="line-about"></span>*/}
            {/*</div>*/}
            <div className="timer-wrapper">
                <span className="number-timer">{days}</span>
                <span className="days-timer">Days</span>
                <span className="number-timer">{hours} </span>
                <span className="days-timer">Hours</span>
                <span className="number-timer">{minutes}</span>
                <span className="days-timer">Minutes</span>
                <span className="number-timer">{seconds}</span>
                <span className="days-timer">Seconds</span>
            </div>
        </div>
    );
};

export default Timer;